import React from 'react';
import ManualPriceWarningStyles from './styled';

export const t = {
  title: 'We don’t have a price/lane for this route.',
  description:
    'Check with your GM to make sure we can do this SO. To set a manual base price, select',
  extra_to_select: 'Modified base price.',
};

const ManualPriceWarning = ({ className }) => {
  return (
    <div className={className}>
      <div className="title">{t.title}</div>
      <div className="description">
        {t.description} <span className="extra">{t.extra_to_select}</span>
      </div>
    </div>
  );
};

export default ManualPriceWarningStyles(ManualPriceWarning);
